'use client'

import { signOut } from 'next-auth/react'

const COOKIE_NAME = process.env.NEXT_PUBLIC_COOKIE_NAME || process.env.COOKIE_NAME || 'PNTKN'

export const SESSION_TOKEN_STORAGE_KEY = COOKIE_NAME
export const SESSION_CLOCK_SKEW_MS = 30 * 1000

export const SESSION_EXPIRED_EVENT = 'tvd:session-expired'

export type SessionExpiredReason = 'idle' | 'unauthorized' | 'refresh-failed'

declare global {
  interface WindowEventMap {
    [SESSION_EXPIRED_EVENT]: CustomEvent<{ reason: SessionExpiredReason }>
  }
}

let logoutPromise: Promise<void> | null = null

export function setSessionCookie(token: string, maxAgeSeconds: number) {
  if (typeof document === 'undefined' || !token || maxAgeSeconds <= 0) return

  document.cookie = `${COOKIE_NAME}=${token}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`

  try {
    localStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token)
  } catch {}
}

export function clearClientSessionArtifacts() {
  if (typeof document !== 'undefined') {
    document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`
  }

  try {
    localStorage.removeItem(SESSION_TOKEN_STORAGE_KEY)
  } catch {}
}

export function emitSessionExpired(reason: SessionExpiredReason) {
  if (typeof window === 'undefined') return

  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { reason } }))
}

export async function performClientLogout(callbackUrl: string = '/login?sessionExpired=1') {
  if (logoutPromise) {
    return logoutPromise
  }

  logoutPromise = (async () => {
    try {
      await fetch('/api/logout', { method: 'GET', cache: 'no-store' })
    } catch {}

    clearClientSessionArtifacts()

    await signOut({ callbackUrl, redirect: true })
  })().finally(() => {
    logoutPromise = null
  })

  return logoutPromise
}
